import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import DoujinInformation from '@/components/disposable/DoujinInformation.vue';
import { Doujin } from '@/model/doujin';
import { ActionMode } from '@/model/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateDoujinView',
  setup(__props) {

const doujin = ref<Doujin>({
	artists: [],
	characters: [],
	code: '',
	imageURL: '',
	link: '',
	source: '',
	tags: [],
	title: ''
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DoujinInformation, {
    doujin: doujin.value,
    mode: _unref(ActionMode).Add
  }, null, 8, ["doujin", "mode"]))
}
}

})